import { useStore } from 'effector-react'
import React, { FC, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import { setSort } from '../../features/cars-list/model'
import { getFromURLFx } from '../../features/city-select/model'
import { $activeDealer } from '../../features/dealer-locator/model'
import { getProjectName } from '../../lib/get-project-name'
import { createMediaStyles } from '../../lib/styled-helpers'
import { Input } from '../input'
import { SelectOptionProps, SelectProps } from './types'

export const Select: FC<SelectProps> = ({
  open = false,
  value = null,
  options,
  renderOptionFn,
  onChange,
  children,
  required,
  ...rest
}) => {
  const [showList, setShowList] = useState<boolean>(open)

  const onListItemClick = (option: SelectOptionProps) => {
    setShowList(false)
    setLocalValue(option)
    onChange(option.value)
  }

  useEffect(() => {
    if (value) {
      setLocalValue(options?.filter((item) => item?.value === value)[0])
      onChange(value)
    }
  }, [value])

  useEffect(() => {
    setShowList(open)
  }, [open])

  const defaultRenderItemFn = (option: SelectOptionProps & { active: boolean }) => {
    return (
      <DefaultOptionWrapper active={option.active}>
        <Name>{option.label}</Name>
      </DefaultOptionWrapper>
    )
  }

  /*Текст выбранной сортировки*/
  const activeOption = options.find((option) => option.value === value) || null
  const [localValue, setLocalValue] = useState(activeOption)
  const activeDealer = useStore($activeDealer)

  useEffect(() => {
    options.map((item) => {
      if (item.active) {
        setLocalValue(item)
        setSort(item.value)
      }
    })
  }, [])

  useEffect(() => {
    if (activeDealer) {
      onChange(activeDealer.id)
    }
  }, [activeDealer])

  let activeDealerString = activeDealer ? activeDealer?.name : ''

  return (
    <Wrapper block={!!rest.block} tabIndex={-1} onFocus={() => setShowList(true)} onBlur={() => setShowList(false)}>
      <InputWrapper>
        <Input {...rest} value={localValue?.label || '' || activeDealerString} block={true} readOnly={true} />
        <Arrow>
          <ArrowSpan isListOpen={showList} />
        </Arrow>
        <List showList={showList}>
          {options.map((option, index) => (
            <Option key={option.label} onClick={() => onListItemClick(option)} isDisabled={!!option.disabled}>
              {renderOptionFn
                ? renderOptionFn({ ...option, active: option === activeOption })
                : defaultRenderItemFn({ ...option, active: option === activeOption })}
            </Option>
          ))}
        </List>
      </InputWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ block: boolean }>`
  position: relative;
  min-width: 100%;
  outline: none;
  border-radius: ${() => getProjectName() === 'avito' && '12px'};

  ${createMediaStyles(() => ({
    tablet: `min-width: 55%;`,
    desktop: `min-width: 50%;`,
    projectors: `min-width: 30%;`
  }))}
`

const InputWrapper = styled.div`
  position: relative;
`

const Arrow = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing[5]};
  top: 50%;
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.palette.brand.primary};
`

const ArrowSpan = styled.span<{ isListOpen: boolean }>`
  border: solid #666;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  margin: 3px 0 0;
  transform: ${({ isListOpen }) => (isListOpen ? 'rotate(-135deg)' : 'rotate(45deg)')};
`

const List = styled.div<{ showList: boolean }>`
  display: ${({ showList }) => (showList ? 'block' : 'none')};
  position: absolute;
  width: 100%;
  top: 100%;
  z-index: 5;

  max-height: 200px;
  background: ${({ theme }) => theme.palette.white};
  overflow: auto;

  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
`

const Option = styled.div<{ isDisabled: boolean }>`
  cursor: pointer;
  pointer-events: ${({ isDisabled }) => isDisabled && 'none'};
`

export const DefaultOptionWrapper = styled.div<{ active: boolean }>`
  color: ${({ theme, active }) => (active ? theme.palette.grey[200] : theme.palette.grey[900])};
  ${({ theme }) => theme.textStyles.p2};
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
  cursor: pointer;
  pointer-events: ${({ active }) => active && 'none'};
  &:hover {
    background: ${({ theme }) => theme.palette.grey[50]};
  }
  z-index: 999;
`

const Name = styled.span``
